import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { AuthState } from '@wilson/auth/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { environment } from '../../../environments/environment';
import {
  RoleAction,
  RolePermissionSubject,
  ShiftExternalWorkflow,
} from '@wilson/interfaces';
import { AbilityServiceSignal } from '@casl/angular';

@Component({
  selector: 'wilson-csv-box-import',
  templateUrl: './csv-box-import.component.html',
  styleUrls: ['./csv-box-import.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CsvBoxImportComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);
  private messageService = inject(NzMessageService);
  private translateService = inject(TranslateService);
  private store = inject(Store);

  @Input() btnText = '';
  @Input() licenseKey = '';
  @Input() hasChangePermissions = false;
  @Input() shiftExternalWorkflows: (ShiftExternalWorkflow & {
    translatedName: string;
  })[] = [];
  csvBoxUser = {};
  isLoading = false;

  @Output() performExternalAction = new EventEmitter<string>();
  get language(): string {
    return (this.translateService.getCurrentLang() ?? '').substring(0, 2);
  }

  RoleAction = RoleAction;
  RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;

  ngOnInit(): void {
    this.csvBoxUser = {
      root_org_unit_id: this.store.selectSnapshot(AuthState.rootOrgUnitId),
      backend_host: environment.backend.host,
      at: this.store.selectSnapshot(AuthState.accessToken),
    };
  }

  async imported(result: boolean): Promise<void> {
    if (result) {
      this.messageService.success(
        this.translateService.instant('csvbox.import.success'),
      );
    } else {
      this.messageService.error(
        this.translateService.instant('csvbox.import.error'),
      );
    }
  }

  onLoadHandler(): void {
    this.isLoading = true;
    this.cdr.detectChanges();
  }

  onImporterReadyHandler(): void {
    this.isLoading = false;
    this.cdr.detectChanges();
  }
}
